import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';
import { IconCam, IconHealth, IconHome, IconLive, IconLogout, IconUptime, IconUsers } from './Icons';

export default function Layout() {
  const { user, logout } = useAuth();

  const initial = (user?.name || user?.username || 'U').slice(0, 1).toUpperCase();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">A</div>
          <div className="brand-name">AeroNMS</div>
        </div>

        <div className="nav-group">
          <div className="nav-label">OPERATIONS</div>
          <NavLink to="/" end className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
            <IconHome /> Home
          </NavLink>
          <NavLink to="/uptime" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
            <IconUptime /> CCTV Uptime
          </NavLink>
          <NavLink to="/health" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
            <IconHealth /> CCTV Health
          </NavLink>
          <NavLink to="/live" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
            <IconLive /> Live View
          </NavLink>
          <NavLink to="/devices" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
            <IconCam /> Devices
          </NavLink>
        </div>

        {user?.role === 'admin' && (
          <div className="nav-group">
            <div className="nav-label">SYSTEM</div>
            <NavLink to="/users" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              <IconUsers /> Users
            </NavLink>
          </div>
        )}

        <div className="sidebar-spacer" />

        <div className="sidebar-user">
          <div className="avatar">{initial}</div>
          <div>
            <strong>{user?.name || user?.username}</strong>
            <small>{user?.email}</small>
          </div>
        </div>
      </aside>

      <div className="main">
        <Outlet
          context={{
            logout,
            LogoutIcon: IconLogout,
          }}
        />
      </div>
    </div>
  );
}

export function HeadActions({ logout, LogoutIcon, children }) {
  return (
    <div className="head-actions">
      {children}
      <button type="button" className="icon-btn" onClick={logout} aria-label="Sign out">
        <LogoutIcon />
      </button>
    </div>
  );
}
